import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-index-page" }
const _hoisted_2 = { class: "product-list-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Søk i varer", -1)
const _hoisted_4 = { class: "product-list-header__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductFilter = _resolveComponent("ProductFilter")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_Messages, { class: "product-index-messages" }),
      _createVNode(_component_Messages, { class: "product-index-messages-fixed" }),
      _createElementVNode("header", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "button-with-icon",
            color: "primary",
            type: "a",
            href: _ctx.addProductLink
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SvgIcon, {
                type: "mdi",
                path: _ctx.newProductIcon
              }, null, 8, ["path"]),
              _createTextVNode(" Legg til produkt")
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_Button, {
            class: "button-with-icon",
            color: "primary",
            type: "a",
            href: _ctx.bulkSaleLink
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SvgIcon, {
                type: "mdi",
                path: _ctx.saleIcon
              }, null, 8, ["path"]),
              _createTextVNode(" Legg til tilbud")
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _createVNode(_component_Card, { class: "product-filter-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_ProductFilter, {
          suppliers: _ctx.suppliers,
          categories: _ctx.categories,
          form: _ctx.form
        }, null, 8, ["suppliers", "categories", "form"])
      ]),
      _: 1
    }),
    _createVNode(_component_ProductList, {
      products: _ctx.products,
      isAdmin: _ctx.isAdmin
    }, null, 8, ["products", "isAdmin"])
  ]))
}